import { render, staticRenderFns } from "./EmptyListImageReviews.vue?vue&type=template&id=be1727ec&scoped=true"
var script = {}
import style0 from "./EmptyListImageReviews.vue?vue&type=style&index=0&id=be1727ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1727ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be1727ec')) {
      api.createRecord('be1727ec', component.options)
    } else {
      api.reload('be1727ec', component.options)
    }
    module.hot.accept("./EmptyListImageReviews.vue?vue&type=template&id=be1727ec&scoped=true", function () {
      api.rerender('be1727ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageReviews.vue"
export default component.exports